(function () {
    'use strict';

    angular
        .module('app')
        .factory('columnFactory', columnFactory);

    columnFactory.$inject = ['$http', '$q', '$filter'];

    function columnFactory($http, $q, $filter) {
        var service = {
            getAvailableColumns: getAvailableColumns,
            getAllColumns: getAllColumns,
            availableColumns: [],
            all: [],
            close: close
        };

        return service;

        function getAvailableColumns() {
            var deferred = $q.defer();
            if (service.availableColumns.length == 0) {
                var request = $http.get('../Synergis.WebApi/api/column/allavailable');
                request.then(function (response) {
                    service.availableColumns = $filter('filter')(response.data, function (value) {
                        return value.displayName != "";
                    });
                    deferred.resolve({ data: service.availableColumns });
                }, function (response) {
                    console.log(response);
                    deferred.reject(response);
                });
            }
            else {
                // Above will set availableColumns to response.data, but resolves to response.
                //deferred.resolve(service.availableColumns);
                var response = { data: service.availableColumns };
                deferred.resolve(response);
            }
            return deferred.promise;
        };

        function getAllColumns() {
            var deferred = $q.defer();
            if (service.all.length == 0) {
                var request = $http.get('../Synergis.WebApi/api/column/all');
                request.then(function (response) {
                    service.all = response.data;
                    deferred.resolve(response);
                }, function (response) {
                    console.log(response);
                    deferred.reject(response);
                });
            }
            else {
                deferred.resolve(service.all);
            }
            return deferred.promise;
        }

        function close() {
            service.all = [];
            service.availableColumns = [];
        }
    }
})();